export default __webpack_public_path__ + "6cc2b0587719410ab004f6fefaf2dd4f.webp";